<template >
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <div id="left">
      <el-form :model="dataForm" :rules="dataRules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
               label-width="150px">
        <el-form-item label="岗点名称" prop="name" >
          <el-input v-model="dataForm.name" sizi="mini" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="经度" prop="x" >
          <el-input v-model="dataForm.x" sizi="mini" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="y" >
          <el-input v-model="dataForm.y" sizi="mini" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="打卡距离" prop="jl" >
          <el-input v-model="dataForm.jl" sizi="mini" autocomplete="off">
          </el-input>
        </el-form-item>
        <el-form-item label="早班人数" prop="morrs" >
          <el-input v-model="dataForm.morrs" :disabled="rsDisabled" sizi="mini" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="早班时间" >
          <el-time-picker placeholder="开始" format="HH:mm" value-format="HH:mm" v-model="bcxxForm.morbc.time[0]" style="width: 50%;"></el-time-picker>
          <el-time-picker placeholder="结束" format="HH:mm" value-format="HH:mm" v-model="bcxxForm.morbc.time[1]" style="width: 50%;"></el-time-picker>
        </el-form-item>
        <el-form-item label="中班人数" prop="aftrs" >
          <el-input v-model="dataForm.aftrs" :disabled="rsDisabled"  sizi="mini" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="中班时间"  >
          <el-time-picker placeholder="开始" format="HH:mm" value-format="HH:mm" v-model="bcxxForm.aftbc.time[0]" style="width: 50%;"></el-time-picker>
          <el-time-picker placeholder="结束" format="HH:mm" value-format="HH:mm" v-model="bcxxForm.aftbc.time[1]" style="width: 50%;"></el-time-picker>
        </el-form-item>

        <el-form-item label="晚班人数" prop="evers">
          <el-input v-model="dataForm.evers" :disabled="rsDisabled"  sizi="mini" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="晚班时间" >
          <el-time-picker placeholder="开始" format="HH:mm" value-format="HH:mm" v-model="bcxxForm.evebc.time[0]" style="width: 50%;"></el-time-picker>
          <el-time-picker placeholder="结束" format="HH:mm" value-format="HH:mm" v-model="bcxxForm.evebc.time[1]" style="width: 50%;"></el-time-picker>
        </el-form-item>

        <el-form-item label="所属大队" prop="bmid">
          <el-select clearable :disabled="deptdisable"  filterable    v-model="dataForm.bmid" placeholder="请选择大队">
            <el-option
                    v-for="item in depts"
                    :key="item.bmid"
                    :label="item.bmmc"
                    :value="item.bmid"
                    :disabled="deptdisable">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="护校岗点">
          <el-switch v-model="dataForm.hxgd" :active-value="1"
                     :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="是否长白班计算">
          <el-switch v-model="dataForm.sfcbb" :active-value="1"
                     :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="学校类型">
          <el-select v-model="dataForm.xxlx" placeholder="请选择" clearable>
            <el-option
              v-for="item in xxlx"
              :key="item.id"
              :label="item.xxmc"
              :value="item.xxlx">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="外借岗点">
          <el-switch v-model="dataForm.wjgd" :active-value="1"
                  :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="早班护校" v-if="showHxForm">
          <el-time-picker placeholder="开始" format="HH:mm" value-format="HH:mm" v-model="bcxxForm.morbc.hxsj[0]" style="width: 50%;"></el-time-picker>
          <el-time-picker placeholder="结束" format="HH:mm" value-format="HH:mm" v-model="bcxxForm.morbc.hxsj[1]" style="width: 50%;"></el-time-picker>
        </el-form-item>
        <el-form-item label="中班护校" v-if="showHxForm">
          <el-time-picker placeholder="开始" format="HH:mm" value-format="HH:mm" v-model="bcxxForm.aftbc.hxsj[0]" style="width: 50%;"></el-time-picker>
          <el-time-picker placeholder="结束" format="HH:mm" value-format="HH:mm" v-model="bcxxForm.aftbc.hxsj[1]" style="width: 50%;"></el-time-picker>
        </el-form-item>
        <el-form-item label="晚班护校" v-if="showHxForm">
          <el-time-picker placeholder="开始" format="HH:mm" value-format="HH:mm" v-model="bcxxForm.evebc.hxsj[0]" style="width: 50%;"></el-time-picker>
          <el-time-picker placeholder="结束" format="HH:mm" value-format="HH:mm" v-model="bcxxForm.evebc.hxsj[1]" style="width: 50%;"></el-time-picker>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>


  export default {
    data () {

      const checkAge = (rule, value, callback) => {
        if(value) {
          if ( !/^\d+$/.test(value)) {
            callback(new Error('请输入数字值'));
          } else {
            callback();
          }
        } else callback();
      }
      return {
        xxlx:[],
        visible: false,
        deptdisable:false,
        depts:[],
        rsDisabled:false,
        dataForm: {
          bmid:'',
          id: '',
          name: '',
          lx: '',
          x: '',
          y: '',
          jl: '',
          rs: '',
          morrs:'',
          aftrs:'',
          evers:'',
          hxgd:0,
          bcList:[],
          contractId:'',
          sfcbb: 0,
          xxlx: '',
          wjgd: 0
        },
        bcxxForm:{
          morbc:{time:['',''],hxsj:['','']},
          aftbc:{time:['',''],hxsj:['','']},
          evebc:{time:['',''],hxsj:['','']}
        },
        showHxForm:false,
        bcxx:[],
        dataRules: {
          name: [{
            required: true,
            message: '岗点名称不能为空',
            trigger: ['blur']
          }],
          x: [{
            required: true,
            message: '经度不能为空',
            trigger: ['blur']
          }],
          y: [{
            required: true,
            message: '纬度不能为空',
            trigger: ['blur']
          }],
          jl: [{
            required: true,
            message: '距离不能为空',
            trigger: ['blur']
          },{
            validator: checkAge,
            message: '距离只能是数字',
            trigger: ['blur']
          }],
          morrs: [{
            validator: checkAge,
            message: '早班人数只能为数字',
            trigger: ['blur']
          }],
          aftrs: [{
            validator: checkAge,
            message: '早班人数只能为数字',
            trigger: ['blur']
          }],
          evers: [{
            validator: checkAge,
            message: '早班人数只能为数字',
            trigger: ['blur']
          }]
        },
        menuList: [],
        hxgd: [],
        menuListTreeProps: {
          label: 'name',
          children: 'children'
        }
      }
    },
    created () {

    },
    methods: {
      isDisabledRs(){

        var userId = this.$store.getters.user.userId;
        var zzdyqc = this.$store.getters.user.zzdyqc;
        if (zzdyqc !== this.CONST_ZN_BM && userId !== '1' && zzdyqc !== '2c9376677a742a05017a83a643b9698b') {
          this.rsDisabled =true;
        }
      },
      typeChange(val) {

      },
      init (id) {
        this.dataForm.id = id || 0
        this.rsDisabled=false
        this.isDisabledRs()
        this.visible = true
        this.$nextTick(() => {
         this.dataForm.bmid=''
         this.dataForm.name=''
         this.dataForm.lx=''
         this.dataForm.x=''
         this.dataForm.y=''
         this.dataForm.jl=''
         this.dataForm.rs=''
         this.dataForm.hxgd=0
         this.dataForm.morrs=''
         this.dataForm.aftrs=''
         this.dataForm.evers=''
         this.dataForm.contractId=''
         this.dataForm.sfcbb = 0
         this.dataForm.xxlx = ''
         this.dataForm.wjgd = 0
          this.bcxxForm.morbc.time=['','']
          this.bcxxForm.aftbc.time=['','']
          this.bcxxForm.evebc.time=['','']
          this.bcxxForm.morbc.hxsj=['','']
          this.bcxxForm.aftbc.hxsj=['','']
          this.bcxxForm.evebc.hxsj=['','']
          let that = this;
          this.$request.get('/bjba/kqtj/getFirstMentForUserXxlx',{
            params: {
              userid:this.$store.getters.username
            }

          }).then(res => {
            console.log("获取部门-学校信息：",res)
            that.depts = res.data.data
            that.xxlx = res.data.xxlx
            if(that.depts && that.depts[0]) {
              var zzdyqc = that.$store.getters.user.zzdyqc;
              if (that.CONST_MOSTHIGH_DEPTS&&!that.CONST_MOSTHIGH_DEPTS.includes(zzdyqc)) {
                var zw = that.$store.getters.user.zw;
                if (zw) {
                  if (zw == '01' || zw == '02' || zw == '03') {
                    that.dataForm.bmid = that.depts[0].bmid
                    that.deptdisable = true
                  }
                }

              }
            }
          }).then(()=> {
            console.log("修改")
            // 修改
            this.$http({
              url: `/bjba/map/info/${this.dataForm.id}`,
              method: 'get'
            }).then(({data}) => {
              console.log('2222222222',data)
              this.dataForm.id=data.gd.gdid;
              this.dataForm.bmid=data.gd.bmid;
              // this.depts.forEach(e => {
              //   if (e.bmid == data.gd.bmid) {
              //     this.dataForm.bmid=data.gd.bmid;
              //   }
              // })
              // this.events.forEach(item => {
              //   let days = item.split('-')
              //   if (days.length == 3 && days[0] == y && Number(days[1]) == (m + 1) && Number(days[2] == d)) {
              //     isContain = true
              //   }
              // })
              this.dataForm.name=data.gd.gdmc;
              this.dataForm.lx=data.gd.gdlx;
              this.dataForm.x=data.gd.zbjd;
              this.dataForm.y=data.gd.zbwd;
              this.dataForm.jl=data.gd.dkjl;
              this.dataForm.morrs=data.gd.morrs;
              this.dataForm.aftrs=data.gd.aftrs;
              this.dataForm.evers=data.gd.evers;
              this.dataForm.bcList = data.bcList;
              this.dataForm.contractId = data.gd.contractId
              this.dataForm.hxgd = data.gd.hxgd
              this.dataForm.sfcbb = data.gd.sfcbb
              this.dataForm.xxlx = data.gd.xxlx
              this.dataForm.wjgd = data.gd.wjgd
              /*for(var i=0;i<this.depts.length;i++) {
                if(this.dataForm.bmid === this.depts[i].bmid) {
                  this.showHxForm = this.depts[i].isSchool ===1
                  break;
                }
              }*/
            })
            this.$request.get('/bjba/map/getBcTime/'+this.dataForm.id).then(res => {
              if(res.data.data && res.data.data.length>0) {
                if(res.data.data && res.data.data.length>0) {
                  for(var i=0;i<res.data.data.length;i++){
                    if(res.data.data[i].bclx=='1'){
                      this.bcxxForm.morbc.time = [res.data.data[i].sbsj,res.data.data[i].xbsj]
                      this.bcxxForm.morbc.hxsj = [res.data.data[i].hxsjks,res.data.data[i].hxsjjs]
                    }else if(res.data.data[i].bclx=='2'){
                      this.bcxxForm.aftbc.time = [res.data.data[i].sbsj,res.data.data[i].xbsj]
                      this.bcxxForm.aftbc.hxsj = [res.data.data[i].hxsjks,res.data.data[i].hxsjjs]
                    } else if(res.data.data[i].bclx=='3'){
                      this.bcxxForm.evebc.time = [res.data.data[i].sbsj,res.data.data[i].xbsj]
                      this.bcxxForm.evebc.hxsj = [res.data.data[i].hxsjks,res.data.data[i].hxsjjs]
                    }
                  }
                } else {
                  this.bcxxForm.morbc.time=['','']
                  this.bcxxForm.aftbc.time=['','']
                  this.bcxxForm.evebc.time=['','']
                  this.bcxxForm.morbc.hxsj=['','']
                  this.bcxxForm.aftbc.hxsj=['','']
                  this.bcxxForm.evebc.hxsj=['','']
                }
              }
            })
          })
        })
      },
      getDepts() {

      },
      // 表单提交
      dataFormSubmit () {

        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            const data = this.dataForm
            data.bcxx = this.bcxxForm
            this.$http({
              url: '/bjba/map/addGdxx',
              method: 'post',
              data      }

            ).then(({data}) => {
              if (data && data.code === 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500
                })
                this.visible = false
                this.$emit('refreshDataList')
              }else if(data && data.code === 500) {
                this.$message({
                  message: data.message,
                  type: "error",
                  duration: 1500
                })
              }
            })
          }
        })
      },
      changeBm(depttype) {
        this.showHxForm = depttype===1
        if(!this.showHxForm) {
          this.bcxxForm.morbc.hxsj=['','']
          this.bcxxForm.aftbc.hxsj=['','']
          this.bcxxForm.evebc.hxsj=['','']
        }
      },
      changeSelect(dept) {
        if(!dept) this.showHxForm = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .el-popper {
    max-height: 500px;
    max-width: 200px;
    overflow-x: hidden;
    overflow-y: auto;
  }
  #left .el-form-item__content{
    text-align: left;
  }
  .menu-list__input,
  .icon-list__input {

    > .el-input__inner {
      cursor: pointer;
    }

  }

  .mod-menu__icon-popover {
    max-width: 350px;
  }

  .mod-menu__icon-list {
    max-height: 380px;
    padding: 0;
    margin: -8px 0 0 -8px;

    > .el-button {
      padding: 8px;
      margin: 8px 0 0 8px;

      > span {
        display: inline-block;
        vertical-align: middle;
        width: 18px;
        height: 18px;
        font-size: 18px;
      }

    }
  }

  .icon-list__tips {
    font-size: 18px;
    text-align: center;
    color: #e6a23c;
    cursor: pointer;
  }
</style>
